<div class="card w-full h-full flex flex-col shadow-sm p-6 rounded-2xl bg-white gap-8">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-col">
      <h1 class="font-semibold text-2xl text-gray-800">
        {{ activeTab === 'MINE' ? 'Mis Pedidos' : 'Todos los Pedidos' }}
      </h1>
      <p class="text-gray-500 mt-1">
        {{ activeTab === 'MINE' 
           ? 'Revisa los pedidos que has creado, edita borradores y consulta su estado.' 
           : 'Supervisa y audita todos los pedidos generados por tu empresa.' }}
      </p>
    </div>
    @if (canCreateOrder && activeTab === 'MINE') {
    <div class="flex flex-col">
      <button class="rounded-3xl flex items-center gap-2 bg-orange-500 hover:bg-orange-600 transition-colors text-white py-3 px-6 cursor-pointer shadow-md shadow-orange-200"
        (click)="openOrderModal()">
        <span class="text-base font-medium">Crear nuevo pedido</span>
        <i class="fi-rr-add text-xl flex"></i>
      </button>
    </div>
    }
  </div>

@if (showTabs) {
  <div class="border-b border-gray-200 mt-2 mb-2 w-full">
    <nav class="-mb-px flex space-x-8" aria-label="Tabs">
      
      <button (click)="switchTab('MINE')" 
        [ngClass]="activeTab === 'MINE' 
          ? 'border-orange-500 text-orange-600' 
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'" 
        class="whitespace-nowrap border-b-2 py-3 px-2 text-base font-medium transition-all duration-200 flex items-center gap-2">
        <i class="fi-rr-user text-lg"></i>
        Mis Pedidos
      </button>

      <button (click)="switchTab('ALL')" 
        [ngClass]="activeTab === 'ALL' 
          ? 'border-orange-500 text-orange-600' 
          : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'" 
        class="whitespace-nowrap border-b-2 py-3 px-2 text-base font-medium transition-all duration-200 flex items-center gap-2">
        <i class="fi-rr-users text-lg"></i>
        Todos los Pedidos
      </button>

    </nav>
  </div>
  }

  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    
    <div class="relative overflow-hidden flex flex-row justify-between items-center rounded-2xl p-6 bg-gradient-to-r from-orange-500 to-secondary-500 shadow-lg shadow-orange-200 text-white transition-transform hover:-translate-y-1 duration-300">
      <div class="flex flex-col gap-1 z-10">
        <span class="text-sm font-medium opacity-90">Total pedidos</span>
        <span class="text-4xl font-bold">{{ totalOrders }}</span>
      </div>
      <div class="z-10 p-3 bg-white/20 rounded-2xl backdrop-blur-sm">
        <img ngSrc="asset/Chart.svg" width="48" height="48" alt="chart" class="opacity-100" />
      </div>
      <div class="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-white/10 blur-2xl"></div>
    </div>

    <div class="relative overflow-hidden flex flex-row justify-between items-center rounded-2xl p-6 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 transition-transform hover:-translate-y-1 duration-300">
      <div class="flex flex-col gap-1 z-10">
        <span class="text-sm text-secondary-75 font-medium">Valor total de pedidos</span>
        <span class="text-3xl font-bold text-secondary-900">${{ totalOrdersValue }}</span>
      </div>
      <div class="z-10 p-3 bg-orange-50 rounded-2xl">
        <img ngSrc="asset/bars.svg" width="48" height="48" alt="chart" />
      </div>
    </div>

    <div class="relative overflow-hidden flex flex-row justify-between items-center rounded-2xl p-6 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-100 transition-transform hover:-translate-y-1 duration-300">
      <div class="flex flex-col gap-1 z-10">
        <span class="text-sm text-secondary-75 font-medium">
          {{ (fechaDesde || fechaHasta) ? 'Periodo filtrado' : 'Último pedido' }}
        </span>
        
        <span class="text-2xl font-bold text-secondary-900 mt-1">
          @if (fechaDesde || fechaHasta) {
            <span class="text-base text-gray-600">
              {{ fechaDesde ? (fechaDesde | date:'dd/MM/yyyy') : '...' }} 
              <span class="mx-1">al</span> 
              {{ fechaHasta ? (fechaHasta | date:'dd/MM/yyyy') : '...' }}
            </span>
          } @else {
            {{ lastOrderDate }}
          }
        </span>
      </div>
      <div class="z-10 w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-50 to-orange-100 flex items-center justify-center">
        <i class="fi-sr-calendar text-orange-500 text-2xl flex items-center"></i>
      </div>
    </div>
    
  </div>

  <div class="flex flex-row flex-wrap items-end justify-start gap-4 bg-gray-50 p-4 rounded-xl border border-gray-100">
    
    <div class="flex flex-col gap-1">
      <label class="text-xs font-semibold text-gray-600">Buscar pedido</label>
      <app-custom-input 
        [placeholder]="'Buscar Pedidos...'" 
        [(value)]="orderNumber"
        (enter)="onPageChange({ page: 0, first: 0, rows: 10 })">
      </app-custom-input>
    </div>
    
    <div class="flex flex-col gap-1 cursor-pointer">
      <label class="text-xs font-semibold text-gray-600">Fecha desde</label>
      <input type="date" [(ngModel)]="fechaDesde"
        class="cursor-pointer border border-gray-300 rounded-lg py-2.5 px-3 bg-white hover:bg-gray-50 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500/50 transition-all" />
    </div>

    <div class="flex flex-col gap-1 cursor-pointer">
      <label class="text-xs font-semibold text-gray-600">Fecha hasta</label>
      <input type="date" [(ngModel)]="fechaHasta"
        class="cursor-pointer border border-gray-300 rounded-lg py-2.5 px-3 bg-white hover:bg-gray-50 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500/50 transition-all" />
    </div>
    
    <div class="flex flex-col gap-1 cursor-pointer min-w-[150px]">
      <label class="text-xs font-semibold text-gray-600">Estado</label>
      <select [(ngModel)]="status" id="status" name="status"
        class="cursor-pointer block w-full border border-gray-300 rounded-lg py-2.5 px-3 bg-white hover:bg-gray-50 text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-500/50 transition-all">
        <option selected="selected" [ngValue]="null">Todos los estados</option>
        @for (item of orderStatusList; track item.key) {
        <option [ngValue]="item.key" class="cursor-pointer">{{ item.value }}</option>
        }
      </select>
    </div>
    
    <div class="flex gap-2">
      <app-button label="Buscar" (click)="onPageChange({ page: 0, first: 0, rows: 10 })"></app-button>
      <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
    </div>

  </div>

  <div class="overflow-x-auto">
    @if (orderList && orderList.length > 0) {
    <div class="card">
      <p-table [value]="orderList" [paginator]="true" [rows]="rows" [first]="first" [lazy]="true"
        [lazyLoadOnInit]="false" (onLazyLoad)="loadOrders($event)" [totalRecords]="totalItems" [sortField]="sortField" [sortOrder]="sortOrder"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas" [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }">
        
        <ng-template #header>
          <tr>
            <th pSortableColumn="orderNumber" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              # Pedido <p-sortIcon field="orderNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="date" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              Fecha <p-sortIcon field="date"></p-sortIcon>
            </th>
            <th pSortableColumn="totalItems" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              # Productos <p-sortIcon field="totalItems"></p-sortIcon>
            </th>
            <th pSortableColumn="value" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              Valor Total <p-sortIcon field="value"></p-sortIcon>
            </th>
            
            <th pSortableColumn="userName" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              Realizado por <p-sortIcon field="userName"></p-sortIcon>
            </th>

            @if (activeTab === 'ALL') {
            <th pSortableColumn="warehouseName" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              Bodega <p-sortIcon field="warehouseName"></p-sortIcon>
            </th>
            }
            <th pSortableColumn="status" class="px-4 py-3 text-left font-semibold text-gray-700"> 
              Estado <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th class="px-4 py-3 text-left font-semibold text-gray-700">Acción</th>
          </tr>
        </ng-template>

        <ng-template #body let-orderList>
          <tr class="hover:bg-orange-50/50 transition-colors border-b border-gray-50">
            <td class="px-6 py-4 font-medium text-gray-800">{{ orderList.orderNumber }}</td>
            <td class="px-6 py-4 text-gray-600">{{ orderList.date | date:'dd/MM/yyyy' }}</td>
            <td class="px-6 py-4 text-gray-600">{{ orderList.totalItems ?? 0 }}</td>
            <td class="px-6 py-4 font-semibold text-gray-800">${{ (orderList.value ?? 0) | number:'1.2-2' }}</td>
            <td class="px-6 py-4 font-medium text-gray-700">
              {{ orderList.userName || 'Usuario ' + orderList.userId }}
            </td>

            @if (activeTab === 'ALL') {
            <td class="px-6 py-4 text-gray-600">{{ orderList.warehouseName || orderList.warehouseCode || 'N/A' }}</td>
            }
            <td class="px-6 py-4">
              <span class="inline-flex px-3 py-1 text-xs font-semibold rounded-full"
                [ngClass]="getBackgroundClasses(orderList.status)">
                {{ getStatusLabel(orderList.status) }}
              </span>
            </td>
            <td class="px-6 py-4">
              <div class="flex flex-row gap-2 items-center">
                <div class="w-8 flex justify-center">
                  <i *ngIf="isInvoiced(orderList.status)"
                    class="fi fi-rr-eye text-xl text-blue-500 hover:text-blue-700 hover:scale-125 transition-all cursor-pointer"
                    title="Ver detalles" (click)="openOrderDetailDialog(orderList)"></i>
                  <i *ngIf="isEditable(orderList.status)"
                    class="fi fi-rr-edit text-xl text-gray-500 hover:text-gray-800 hover:scale-125 transition-all cursor-pointer" title="Editar"
                    (click)="viewOrderItems(orderList.id)"></i>
                </div>
                <div class="w-8 flex justify-center">
                  <i class="fi fi-rr-download text-xl text-green-500 hover:text-green-700 hover:scale-125 transition-all cursor-pointer" title="Descargar"
                    (click)="downloadOrderExcel(orderList.id)"></i>
                </div>
                <div class="w-8 flex justify-center">
                  <i *ngIf="isEditable(orderList.status)"
                    class="fi fi-rr-trash text-xl text-red-500 hover:text-red-700 hover:scale-125 transition-all cursor-pointer" title="Eliminar"
                    (click)="deleteOrder(orderList)"></i>
                </div>

              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center bg-gray-50 p-12 rounded-2xl border border-dashed border-gray-200">
      <i class="fi-rr-box text-4xl text-gray-300 mb-3"></i>
      <span class="text-gray-500 font-medium">No se encontraron pedidos con estos filtros</span>
    </div>
    }

  </div>
</div>